<div style="width: 100%; height: 26rem; padding-left: 1rem;">
  <canvas
    baseChart
    [datasets]="lineChartData"
    [options]="lineChartOptions"
    [legend]="lineChartLegend"
    [type]="'scatter'">
  </canvas>
</div>
